import { StateModel } from '../../shared/models/default-state.model';
import {
  GET_TALENT_POOL_APPLICANTS_REQUEST,
  GET_TALENT_POOL_APPLICANTS_SUCCESS,
  GET_TALENT_POOL_APPLICANTS_ERROR,
  GET_TALENT_POOL_APPLICANT_REQUEST,
  GET_TALENT_POOL_APPLICANT_SUCCESS,
  GET_TALENT_POOL_APPLICANT_ERROR,
  CLEAR_TALENT_POOL_APPLICANTS,
} from '../actions/talent-pool.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: [],
};

export const talentPoolApplicantsReducer = (state: StateModel = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case GET_TALENT_POOL_APPLICANTS_REQUEST:
      return {
        ...state,
        loaded: false,
        loading: true,
      };

    case GET_TALENT_POOL_APPLICANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
      };

    case GET_TALENT_POOL_APPLICANTS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    case CLEAR_TALENT_POOL_APPLICANTS:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export const talentPoolApplicantReducer = (state: StateModel = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case GET_TALENT_POOL_APPLICANT_REQUEST:
      return {
        ...state,
        loaded: false,
        loading: true,
      };

    case GET_TALENT_POOL_APPLICANT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.payload,
      };

    case GET_TALENT_POOL_APPLICANT_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };

    default:
      return state;
  }
};
